module.exports = __webpack_public_path__ + "static/media/lg13.5ba8eb39.png";